import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useDropdowns() {
  return useQuery({
    queryKey: ["dropdowns"],
    queryFn: async () => (await api.get("/settings/dropdowns")).data.dropdown_configs,
    staleTime: 5 * 60 * 1000,
  });
}

export function useAssignable(role, divisionId) {
  return useQuery({
    queryKey: ["assignable", role, divisionId],
    queryFn: async () => {
      const params = {};
      if (role) params.role = role;
      const { data } = await api.get("/users/assignable", { params });
      return divisionId ? data.filter((u) => u.division_id === divisionId) : data;
    },
  });
}

export function useDivisions() {
  return useQuery({
    queryKey: ["divisions"],
    queryFn: async () => (await api.get("/divisions")).data,
    staleTime: 10 * 60 * 1000,
  });
}
